import clsx from 'clsx'
import React, { FC, useContext, useEffect, useState } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './TrustPilotWidget.module.scss'

const useTrustPilotScript = (shouldRender: boolean) => {
  useEffect(() => {
    if (!shouldRender) {
      return
    }

    const tpScriptID = 'th-trustpilot-v5'
    const hasScriptLoaded = !!document.getElementById(tpScriptID)

    if (hasScriptLoaded) {
      return
    }

    const tpScript = document.createElement('script')
    tpScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    tpScript.id = tpScriptID
    tpScript.async = true

    document.body.appendChild(tpScript)
  }, [shouldRender])
}
export const TRUST_PILOT_WIDGET_TEMPLATE_MICRO_STAR = '5419b732fbfb950b10de65e5'

interface TrustPilotWidgetProps {
  className?: string
  link?: boolean
  trustPilotWidgetTemplate?: string
}

export const TrustPilotWidget: FC<TrustPilotWidgetProps> = ({ className, link = true, trustPilotWidgetTemplate = '53aa8912dec7e10d38f59f36' }) => {
  const { store } = useContext(MetadataContext)
  const [loaded, setLoaded] = useState(false)
  const trustAreaV1 = useSplitTest('trust_area_v1')

  const trustPilotBusinessID = store?.config?.trustpilotBusinessID
  const trustPilotDomain = store?.config?.trustpilotDomain
  const localeCode = store?.config?.localeCode
  const storeHost = store?.config?.urlDomain

  const shouldRender = !!(trustPilotBusinessID && trustPilotDomain) && trustAreaV1 !== 'b'

  useTrustPilotScript(shouldRender)

  useEffect(() => {
    const win = window as any
    if (win?.Trustpilot && !loaded) {
      const elements = document.querySelectorAll('.trustpilot-widget')
      elements.forEach((element) => {
        setLoaded(true)
        win.Trustpilot?.loadFromElement(element)
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!shouldRender) {
    return <div />
  }

  return (
    <div
      className={clsx(`${className} trustpilot-widget`, !link && styles.noLink)}
      data-businessunit-id={trustPilotBusinessID}
      data-locale={localeCode}
      data-stars="4,5"
      data-style-height="140px"
      data-style-width="100%"
      data-template-id={trustPilotWidgetTemplate}
      data-theme="light"
    >
      <a href={`https://${trustPilotDomain}/review/${storeHost}`} rel="noreferrer" target="_blank">
        Trustpilot
      </a>
    </div>
  )
}
